import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/team-form.schema';
import { useCreateTeamMutation } from '../mutations';
import { TeamForm } from './components/team-form';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export function Page() {
  const mutation = useCreateTeamMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync({ payload }), {
      success: 'Laget har skapats',
      pending: 'Skapar lag...',
    });

    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa lag" />

      <PageLayout.Section>
        <TeamForm onSubmit={onSubmit} isLoading={mutation.isPending} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
}
